import axios from "axios";
import config from "../../config";
import auth from "../common/Auth";
import { Error } from './base';

export const changePasswordAPI = (header, newPassword) => {
    
    const user = auth.getSessionUser();
    
    const encodeUserId = encodeURI(user.id)
    
    console.log(user.id)
    console.log(encodeUserId)

    //https://sinexiar.com/smre/management/clients/ecu/users/{String:urlencoded(id)}/password
    return new Promise((resolve, reject) => {
        axios.patch(
            `${ config.get("re.management") }clients/ecu/users/${ encodeUserId }/password`,
            newPassword,
            header,
        ).then(response => {
            if (response.status >= 200 && response.status < 400) {
                console.log(response.date)
                resolve(response.data);
            } 
            else {
                const err = new Error(response.status, this.context.t("Something went wrong when trying to create a new password"), JSON.stringify(response.data));
                reject(err);
            }
        }).catch(err => {
            reject(err);
        });
    });
}